import { render } from "./CustomHtmlInput.vue?vue&type=template&id=e9d60222"
import script from "./CustomHtmlInput.vue?vue&type=script&lang=js"
export * from "./CustomHtmlInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__